import { useState, useCallback } from 'react';
import { Route, Switch } from 'react-router-dom';

// Components
import AddresDetail from '../AddresDetail';
import AddressForm from '../AddressForm';

// Queries
import postGlobal from '../Queries/postGlobal';

// Styles
import styles from './index.module.sass';

export default function Address({ history, match, getCookie, webservice, device }) {
  const [orderData, setOrderData] = useState({});
  const [loading, setLoading] = useState(false);

  const getOrder = useCallback(
    async (action, cat, id, quantity, lineNum, neddLoading) => {
      setLoading(neddLoading);

      const order = await postGlobal({
        tmbservice: 'getAgregarAlCarrito',
        jsonBody: {
          accion: action,
          usuarioOK: getCookie('usuarioOk'),
          folioPedido: getCookie('folioPedido'),
          almacen: getCookie('warehouse'),
          categoria: cat,
          clave: id,
          cantidad: quantity,
          numeroLinea: lineNum,
          textoProdSeleccion: '',
          idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          origen: 'CARRITONUE',
        },
      });

      setOrderData(order || {});
      setLoading(false);
    },
    [getCookie],
  );

  return (
    <div className={styles.container}>
      <Switch>
        <Route
          path={`${match.path}/form`}
          render={(props) => {
            return (
              <AddressForm
                {...props}
                device={device}
                history={history}
                getOrder={getOrder}
                orderData={orderData}
                getCookie={getCookie}
                webservice={webservice}
                redirect='/cart/order/addressdetail'
              />
            );
          }}
        />
        <Route
          path={`${match.path}`}
          render={(props) => {
            return (
              <AddresDetail
                {...props}
                device={device}
                history={history}
                loading={loading}
                getOrder={getOrder}
                orderData={orderData}
                getCookie={getCookie}
              />
            );
          }}
        />
      </Switch>
    </div>
  );
}
